module.exports = __webpack_public_path__ + "static/media/5-Night.1fe8ff18.webp";